(function () {
    'use strict';

    /* chart module*/
    var module = angular.module('uwAgenda.charts', [
        'uwAgenda.help',
        'uwAgenda.global',
        'uwAgenda.settings.messages',
        'uwAgenda.downloads'
    ]);
    module.constant('ChartViewType', {
        "Day": { name: "Day", value: 0 },
        "Week": { name: "Week", value: 1 },
        "Year": { name: "Year", value: 2 }
    });
    module.constant('ChartDataType', {
        "Appointment": 0,
        "DayTask": 1,
        "Message": 2
    });
    module.constant('PatientState', {
        "Known": { name: "Known", value: 1 },
        "Unknown": { name: "Unknown", value: 2 }
    });
    module.constant('ChartFilterBroadcast', {
        "MessageTypeRefresh": "messageType:filterRefresh",
        "PatientStateRefresh": "patientState:filterRefresh"
    });

    module.config(['$stateProvider', 'HelpCategoryEnum', function ChartsConfigFn($stateProvider, HelpCategoryEnum) {
        $stateProvider
        .state('Home.Statistics', {
            url: 'Statistics',
            templateUrl: '/app/charts/templates/charts.template.html',
            params: {
                helpCategory: HelpCategoryEnum.Statistic
            },
            resolve: {
                deps: ['$ocLazyLoad', function ($ocLazyLoad) {
                    return $ocLazyLoad.load({
                        name: 'uwAgenda Charts',
                        serie: true,
                        insertBefore: '#ng_load_plugins_before',
                        files: [
                            '/assets/lib/lazy-loaded/profile.css',
                            '/assets/lib/lazy-loaded/todo-2.min.css',

                            '/assets/lib/lazy-loaded/todo-2.min.js',
                            '/assets/lib/lazy-loaded/jquery.sparkline.min.js',
                            '/assets/lib/lazy-loaded/profile.min.js'
                        ]
                    });
                }]
            },
            data: {
                requiresLogin: true
            },
            ncyBreadcrumb: {
                label: "{{'statistics' | translate}}"
            }
        })
        .state('Home.Statistics.Appointments', {
            url: '/Appointments',
            templateUrl: '/app/charts/templates/chart-overview.template.html',
            controller: 'ChartOverviewController',
            controllerAs: 'vm',
            params: {
                helpCategory: HelpCategoryEnum.Statistic
            },
            resolve: {
                chartType: ['ChartDataType', function (ChartDataType) {
                    return ChartDataType.Appointment;
                }],
                agendaLabels: ['AgendaLabelService', 'SharedAgendaService', function (AgendaLabelService, SharedAgendaService) {
                    return AgendaLabelService.query(SharedAgendaService.data.currentAgenda.id, false);
                }]
            },
            data: {
                requiresLogin: true
            },
            ncyBreadcrumb: {
                label: "{{'appointments' | translate}}"
            }
        })
        .state('Home.Statistics.Daytasks', {
            url: '/Daytasks',
            templateUrl: '/app/charts/templates/chart-overview.template.html',
            controller: 'ChartOverviewController',
            controllerAs: 'vm',
            params: {
                helpCategory: HelpCategoryEnum.Statistic
            },
            resolve: {
                chartType: ['ChartDataType', function (ChartDataType) {
                    return ChartDataType.DayTask;
                }],
                agendaLabels: ['AgendaLabelService', 'SharedAgendaService', function (AgendaLabelService, SharedAgendaService) {
                    return AgendaLabelService.query(SharedAgendaService.data.currentAgenda.id, false);
                }]
            },
            data: {
                requiresLogin: true
            },
            ncyBreadcrumb: {
                label: "{{'daytasks' | translate}}"
            }
        })
        .state('Home.Statistics.Messages', {
            url: '/Messages',
            templateUrl: '/app/charts/templates/chart-overview.template.html',
            controller: 'ChartOverviewController',
            controllerAs: 'vm',
            params: {
                helpCategory: HelpCategoryEnum.Statistic
            },
            resolve: {
                chartType: ['ChartDataType', function (ChartDataType) {
                    return ChartDataType.Message;
                }],
                agendaLabels: ['AgendaLabelService', 'SharedAgendaService', function (AgendaLabelService, SharedAgendaService) {
                    return AgendaLabelService.query(SharedAgendaService.data.currentAgenda.id, false);
                }]
            },
            data: {
                requiresLogin: true
            },
            ncyBreadcrumb: {
                label: "{{'calls_messages' | translate}}"
            }
        });
    }]);

})();